import { render, staticRenderFns } from "./SupervisorIndicators.vue?vue&type=template&id=1590e473"
import script from "./SupervisorIndicators.vue?vue&type=script&lang=js"
export * from "./SupervisorIndicators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports